import React, {useEffect, useRef, useState} from 'react';
import Loading from "../../UiComponents/Loading";
import ErrorCardController from "../../UiComponents/ErrorCardController";
import {
  Button,
  Grid,
  IconButton,
  Paper,
  Table, TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow, TextField,
  Toolbar,
  Typography
} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import {leaderboardRepository} from "../../../Domain/Repositories/LeaderboardRepository";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  title: {
    flexGrow: 1
  },
  clickableCell: {
    cursor: 'pointer',
  },
}));

export default function LeaderboardContent()
{
  const classes = useStyles();
  const history = useHistory();

  const errorCardControllerRef = useRef<ErrorCardController>(null);

  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState<Date>(new Date(new Date().getTime() - 3600000));
  const [toDate, setToDate] = useState<Date>(new Date());

  const forceReload = () =>
  {
    setLoading(true);
    leaderboardRepository.load(fromDate, toDate)
      .then(() => setLoading(false))
      .catch((e: Error) =>
      {
        setLoading(false);
        errorCardControllerRef.current?.addErrorMessage(e.message);
      })
  }

  useEffect(() =>
  {
    forceReload();
  }, [])

  return (
    <>
      <Loading isLoading={loading}>
        <ErrorCardController ref={errorCardControllerRef}/>

        <Paper className={classes.paper}>
          <Toolbar>
            <Typography className={classes.title} component="h2" variant="h6" color="primary" gutterBottom>
              Leaderboard
            </Typography>
          </Toolbar>

          <Grid container>
            <Grid item md={3}>
              <TextField
                id="datetime-from"
                label="From"
                type="datetime-local"
                value={new Date(fromDate.getTime() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 16)}
                onChange={(e) => setFromDate(new Date(e.currentTarget.value))}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item md={3}>
              <TextField
                id="datetime-to"
                label="To"
                type="datetime-local"
                value={new Date(toDate.getTime() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 16)}
                onChange={(e) => setToDate(new Date(e.currentTarget.value))}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item md={6}>
              <Button onClick={forceReload}
                      color="primary"
                      variant="contained"
              >
                Refresh
              </Button>
            </Grid>
          </Grid>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Score</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {leaderboardRepository.leaderboardEntries
                    .sort((a, b) => b.totalScore - a.totalScore)
                    .map((row, index) => (
                  <TableRow key={`${row.teamName}_${row.totalScore}_${index}`} hover>
                    <TableCell>{row.teamName}</TableCell>
                    <TableCell>{row.totalScore}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </Paper>
      </Loading>
    </>
  );
}